import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { ApplicationRouteSegments, ProcessedAuthCodes } from '../../enums/enums';
import { AuthService } from '../../../auth/auth.service/auth.service';
import {AppSettingsService} from '../../services/app-settings/app-settings.service';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
    private router: Router) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          const { url } = request;

          if(url.includes('connect/token')) {
            return this.router.navigate([{outlets: {popup: ['session_error']}}]);
          }

          const { status } = error;

          if(!url.includes(AppSettingsService.authServiceUrl)
            && !url.includes(AppSettingsService.authServiceUrl?.replace('auth', 'wallet'))
            && !url.includes(AppSettingsService.authServiceUrl?.replace('auth', 'portal'))) {
            return throwError(error);
          }

          switch (status) {
            case ProcessedAuthCodes.notAuthenticated: {
              this.authService.logoff();
              this.router.navigate([{ outlets: { popup: null } }]);
              this.router.navigate(['/']);
              break;
            }

            case ProcessedAuthCodes.notAuthorized: {
              this.router.createUrlTree([ApplicationRouteSegments.unauthorized]);
              break;
            }

            default: {
              throwError(error);
              break;
            }
          }

          return throwError(error);
        }),
      ) as Observable<HttpEvent<unknown>>;
  }
}
